<script>
  import { getContext } from "svelte";

  import TypeformEmbed from "./TypeformEmbed.svelte";
  import YoutubeEmbed from "./YoutubeEmbed.svelte";
  import TwitterEmbed from "./TwitterEmbed.svelte";
  import FacebookEmbed from "./FacebookEmbed.svelte";
  import InstagramEmbed from "./InstagramEmbed.svelte";
  import DoubleTheDonation from "./DoubleTheDonation.svelte";
  import SoundCloudEmbed from "./SoundCloudEmbed.svelte";

  let clazz = null;
  export { clazz as class };

  export let data;
  let containerized = getContext("containerized");

  /**
   * TODO: Implement the following unsupported embed types: Google Maps, Juxtapose, and Spotify.
   *
   * Corresponding form factors to be used in the map for future reference:
   *
   * googlemaps -> Google Maps
   * juxtapose -> Juxtapose
   * spotify -> Spotify
   */
  const SOURCE_MAP = {
    facebook: FacebookEmbed,
    instagram: InstagramEmbed,
    twitter: TwitterEmbed,
    typeform: TypeformEmbed,
    youtube: YoutubeEmbed,
    "Double the Donation": DoubleTheDonation,
    soundcloud: SoundCloudEmbed
  };
  let component = SOURCE_MAP[data.fields.source];
</script>

<svelte:component
  this={component}
  {data}
  fullWidth={!containerized}
  class="{clazz} embedded-content"
/>
